import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";

const EuropeanAccommodation = () => {
  return (
    <div className="border border-yellow-800 rounded-md p-2 bg-yellow-50">
      <div className="flex items-center gap-4 text-xs text-secondary">
        {/* <AiOutlineInfoCircle size={20} className="text-yellow-800" /> */}
        <AiOutlineInfoCircle className="text-yellow-800 w-10 h-10 md:w-5 md:h-5" />
        <div>
          <p className="text-sm">
            Accommodation will be arranged in triple or quadruple sharing rooms,
            based on availability.
          </p>
          <p className="text-sm">
            Double-room accommodation may be provided at an additional cost,
            subject to availability.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EuropeanAccommodation;
